<template>
    <div class="fillBlank">
        <div class="fillBlank-index">{{questionnKey}}、</div>
        <div class="fillBlank-item" v-for="(item, key) in renderList" :key="key">
            <div class="fillBlank-item-blank" v-if="item.type === 'input'">
                <input :maxlength="maxlength" :disabled="disabled" v-model="componentValue[item.blankIndex]" type="text" name="" id="" @input="handleInput($event, item.blankIndex)" />
                <label for="">{{componentValue[item.blankIndex]}}</label>
            </div>
            <div class="fillBlank-item-text" v-else>{{item.text}}</div>
        </div>
        <div class="fillBlank-index" style="position: relative; top: -0.1rem">{{score ? `（${score}分）` : ""}}</div>
    </div>
</template>

<script>
import { filterFillBlankText } from "@/utils/common"
export default {
    data() {
        return {
            componentValue: [],
            renderList: []
        }
	},
	model: {
		prop: 'value',
		event: 'change'
	},
    props: {
        value: {
            type: Array,
            default: () => {
                return []
            }
        },
        content: {
            type: String,
            default: ""
        },
        questionnKey: {
            type: Number,
            default: 0
        },
		disabled: {
			type: Boolean,
			default: false
        },
        maxlength: {
            type: String | Number,
            default: 50
        },
        score: {
			type: String,
			default: ""
		}

    },
	mounted() {
		this.componentValue = [...this.value]
		const contentList = filterFillBlankText(this.content).split('@@@')
		let blankIndex = 0, renderList = []
		for (let i = 0; i < contentList.length; i++) {
			const content = contentList[i]
			if (content === '###') {
				renderList.push({
					type: 'input',
					blankIndex: blankIndex++
				})
			} else {
				renderList.push({
					type: 'text',
					text: content
				})
			}
		}
        this.renderList = renderList
	},
	methods: {
		/**
            输入框输入时触发
            @params { Event }  event 输入事件参数
			@params { Number }  key 下标
            @return
        */
        handleInput(event, key) {
			const componentValue = [...this.componentValue]
			componentValue[key] = event.target.value
			this.$emit('change', componentValue)
		}
	},
	watch: {
		value: {
			handler(newValue) {
				this.componentValue = newValue
			},
			deep: true
		}
	}
}
</script>

<style lang="scss" scoped>
.fillBlank {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    .fillBlank-index {
        font-size: 0.3rem;
        font-weight: bold;
        line-height: 0.42rem;
    }
    .fillBlank-item {
		margin-bottom: 0.16rem;
		//margin-right: 0.16rem;
        .fillBlank-item-blank {
            position: relative;
			height: 0.56rem;
			min-width: 1.44rem;
			max-width: 6.2rem;
			overflow: hidden;
            > label {
                padding: 0.07rem 0.32rem 0.07rem;
                font-size: 0.3rem;
				opacity: 0;
            }
            > input {
				z-index: 2;
				position: absolute;
				left: 0;
				top: 0;
				width: 100%;
                padding: 0.07rem 0.32rem 0.07rem;
                height: 0.56rem;
                border: none;
				border-radius: 0.16rem;
                background-color: #efefef;
				//border-bottom: 1px solid #333;
                outline: none;
            }
        }
        .fillBlank-item-text {
            font-size: 0.3rem;
            //font-weight: bold;
            line-height: 0.42rem;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/reserve/questionnaire/components/fillBlank.vue